import { render, staticRenderFns } from "./UoDashboard.vue?vue&type=template&id=25b6f8f2&"
import script from "./UoDashboard.vue?vue&type=script&lang=js&"
export * from "./UoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports